import React from 'react';
import { bookingSteps } from '../data/mock';
import { MessageSquare, Car, CheckCircle, Smile } from 'lucide-react';

const stepIcons = [MessageSquare, Car, CheckCircle, Smile];

const HowItWorks = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
            How It Works
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Simple, Fast & Reliable
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Book your perfect ride in just 4 easy steps.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-1/2 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 -translate-y-1/2" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {bookingSteps.map((step, index) => {
              const IconComponent = stepIcons[index];
              return (
                <div key={step.id} className="relative">
                  <div className="flex flex-col items-center text-center group">
                    {/* Step Number Circle */}
                    <div className="relative">
                      <div className="w-20 h-20 bg-white border-4 border-amber-400 rounded-full flex items-center justify-center shadow-lg shadow-amber-100 group-hover:border-amber-500 group-hover:shadow-xl group-hover:shadow-amber-200 transition-all duration-300 z-10 relative">
                        <IconComponent className="w-8 h-8 text-amber-500" />
                      </div>
                      <span className="absolute -top-2 -right-2 w-8 h-8 bg-amber-500 text-white text-sm font-bold rounded-full flex items-center justify-center shadow-md">
                        {step.step}
                      </span>
                    </div>
                    
                    {/* Content */}
                    <div className="mt-6">
                      <h3 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-amber-600 transition-colors">
                        {step.title}
                      </h3>
                      <p className="text-slate-500 text-sm max-w-[200px] mx-auto">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
